import { useEffect, useState } from 'react';

export default function StickyApplyBar({ onApplyClick }: { onApplyClick: () => void }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-edept-light-gray bg-white/95 p-3 shadow-card-lg backdrop-blur lg:hidden">
      <button
        type="button"
        onClick={onApplyClick}
        className="block w-full rounded-full bg-edept-orange px-6 py-3.5 text-center text-sm font-semibold text-white shadow-card"
      >
        Request a Callback
      </button>
    </div>
  );
}
